import React from "react";
import {useTranslation} from "react-i18next";
import styled from "styled-components";
import {
  WATERSPEED_PRICING_PATH,
  WATERSPEED_PRIVACY_LINK,
  WATERSPEED_REFUND_LINK,
  WATERSPEED_TERMS_LINK
} from "constants/AppConstants.js";
import {ws} from "styles/tokens";

const Footer = styled.footer`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 4px 16px;
  padding: 16px;
  font-size: 13px;

  a {
    color: ${ws.muted};
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }
`;

/** Plans, terms, privacy and refund policy: Paddle's domain review looks for them before allowing a checkout. */
function LegalLinks() {
  const {t} = useTranslation();
  return (
    <Footer>
      {/* A plain link, not a router Link: the pricing page is static HTML outside the app */}
      <a href={WATERSPEED_PRICING_PATH}>{t("pricing.footerLink")}</a>
      <a href={WATERSPEED_TERMS_LINK} target="_blank" rel="noreferrer">
        {t("settings.terms")}
      </a>
      <a href={WATERSPEED_PRIVACY_LINK} target="_blank" rel="noreferrer">
        {t("settings.privacyPolicy")}
      </a>
      <a href={WATERSPEED_REFUND_LINK} target="_blank" rel="noreferrer">
        {t("settings.refundPolicy")}
      </a>
    </Footer>
  );
}

export default LegalLinks;
